module.exports = __webpack_public_path__ + "static/media/Apple iPhone XR Silver.bb277737.png";